<div class="layout-body" [class.layout-body-alt]="!this.authenticateComplete">
    <div *ngIf="this.authenticateComplete; then normalHeader; else authHeader">
    </div>
    <!-- Public Layout -->
    <ng-template #authHeader>
        <q-layout-public>
            <router-outlet></router-outlet>
        </q-layout-public>
    </ng-template>

    <!-- Secure Layout -->
    <ng-template #normalHeader>
        <q-layout-secure>
            <q-auth-frame-token-refresh></q-auth-frame-token-refresh>
            <router-outlet></router-outlet>
        </q-layout-secure>
    </ng-template>
</div>
